import { Button, ModalProps } from 'antd';
import { ScreenRecordingPolicyModalStyled } from './styled';
import SVG from 'react-inlinesvg';

interface ScreenRecordingPolicyModalProps {
    visible: boolean;
    onClose: () => void;
}

export const ScreenRecordingPolicyModal: React.FC<ScreenRecordingPolicyModalProps> = ({
    ...props
}: ScreenRecordingPolicyModalProps) => {
    const modalConfig: ModalProps = {
        open: props.visible,
        onCancel: props.onClose,
        width: 500,
        closable: false,
        footer: null
    };

    const handleAccept = () => {
        window.localStorage.setItem('screenRecordingPolicyAccepted', 'true');
        props.onClose();
    };

    return (
        <ScreenRecordingPolicyModalStyled {...modalConfig}>
            <SVG src='/images/screen-capture-policy-cover.svg' />
            <h1>ข้อกำหนดการใช้งานของ Hibrary</h1>
            <p>
                <b>ไม่อนุญาตให้บันทึกภาพหน้าจอหรือวิดีโอขณะเปิดอ่าน</b> <br />
                เพื่อรักษาสิทธิ์ในทรัพย์สินทางปัญญาของเจ้าของลิขสิทธิ์ <br />
                หากพบว่ามีการฝ่าฝืนข้อกำหนดระบบจะดำเนินการระงับ <br />
                การใช้งาน และไม่สามารถเข้าถึงแอปพลิเคชันได้อีก
            </p>

            <Button shape='round' size='large' type='primary' onClick={handleAccept}>
                ตกลง
            </Button>
        </ScreenRecordingPolicyModalStyled>
    );
};

export default ScreenRecordingPolicyModal;
